import { Component, OnInit, Input, SimpleChanges } from "@angular/core";
import { Router } from "@angular/router";
import { Dictionary } from "src/app/store/models/common_types";
import { ResearchPageDataService } from "../research-page-data.service";
import { AppService } from "src/app/app.service";

@Component({
  selector: "app-more-analyst-research",
  templateUrl: "./more-analyst-research.component.html",
  styleUrls: ["./more-analyst-research.component.scss"],
})
export class MoreAnalystResearchComponent implements OnInit {
  @Input() analystList;
  @Input() researchDocId;
  @Input() documentType;
  moreAnalyst: Array<Dictionary<any>>;
  constructor(
    private dataService: ResearchPageDataService,
    private router: Router,
    private appService: AppService,
  ) {}

  ngOnInit() {
    this.analystList = [];
  }
  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.analystList &&
      changes.analystList.currentValue !== undefined &&
      changes.analystList.currentValue.length > 0
    ) {
      this.dataService
        .getDocuments(this.analystList[0].email)
        .subscribe((data: any) => {
          this.moreAnalyst = data;
          if (this.moreAnalyst.length > 20) {
            this.moreAnalyst = this.moreAnalyst.slice(0, 20);
          }
        });
    }
  }
  researchRedirect(link) {
    const extras = {
      beginning_state_referrer: "File_Viewer",
      research_id: this.researchDocId,
      research_type: this.documentType,
    };
    this.appService.logUserAction(
      {},
      "",
      "",
      "Research_Opened_FromViewer_SP",
      extras,
      "",
      "Research_MoreFromAnalyst",
    );
    this.router.navigateByUrl(link);
  }
}
